import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 100);
    } else {
      const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 rounded-lg btn-gradient flex items-center justify-center">
                <span className="text-white font-heading font-bold text-sm">TP</span>
              </div>
              <div className="leading-tight">
                <span className="font-heading text-[15px] font-semibold text-white block">Trademark Protection</span>
                <span className="text-gradient text-xs font-semibold">For Logos</span>
              </div>
            </div>
            <p className="text-sm text-[#71717A] leading-relaxed">
              Your trusted partner for logo trademark registration, protection, and monitoring in the United States.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', id: 'home' },
                { label: 'Why Trademark', id: 'why-need' },
                { label: 'Our Services', id: 'services' },
                { label: 'How It Works', id: 'process' },
                { label: 'Pricing', id: 'pricing' },
                { label: 'Testimonials', id: 'testimonials' },
                { label: 'FAQ', id: 'faq' },
              ].map((item) => (
                <li key={item.id}><button onClick={() => scrollToSection(item.id)} className="text-sm text-[#71717A] hover:text-[#3B82F6] transition-colors footer-link inline-block">{item.label}</button></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#3B82F6] mt-0.5 shrink-0" />
                <a href="tel:+18005551234" className="text-sm text-[#71717A] hover:text-white transition-colors">(800) 555-1234</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#3B82F6] mt-0.5 shrink-0" />
                <a href="mailto:info@trademarkprotectionforlogos.com" className="text-sm text-[#71717A] hover:text-white transition-colors break-all">info@trademarkprotectionforlogos.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#3B82F6] mt-0.5 shrink-0" />
                <span className="text-sm text-[#71717A]">18952 MacArthur Blvd Suite 100<br />Irvine, CA 92612</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#52525B]">&copy; {currentYear} Trademark Protection For Logos. All rights reserved.</p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy-policy" className="text-[#52525B] hover:text-[#3B82F6] transition-colors">Privacy Policy</Link>
            <Link to="/terms-conditions" className="text-[#52525B] hover:text-[#3B82F6] transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
